import { createAsyncThunk } from '@reduxjs/toolkit';
import authService from '../../../api/services/auth';

export const signUp = createAsyncThunk('auth/sign-up', async requestData => {
  return await authService.signUp(requestData);
});

export const login = createAsyncThunk('auth/login', async requestData => {
  return await authService.login(requestData);
});

export const refresh = createAsyncThunk('auth/refresh', async () => {
  return await authService.refresh();
});

export const logout = createAsyncThunk('auth/logout', async (_, thunkAPI) => {
  thunkAPI.dispatch({ type: 'logout' });
  // thunkAPI.dispatch({ type: "reset" });
  return await authService.logout();
});

export const sendCodeForNewPassword = createAsyncThunk('auth/send-code-for-new-password', async requestData => {
  return await authService.sendCodeForNewPassword(requestData);
});

export const resetPassword = createAsyncThunk('auth/reset-password', async requestData => {
  return await authService.resetPassword(requestData);
});

export const sendVerificationCodeEmailAgain = createAsyncThunk('auth/send-verification-code-email-again', async requestData => {
  return await authService.sendVerificationCodeEmailAgain(requestData);
});
